import {
  FileExcelOutlined,
  ReloadOutlined,
  SearchOutlined
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Layout,
  Row,
  Select,
  Table
} from "antd";
import { ColumnsType } from "antd/es/table";
import { get, isEmpty, toNumber } from "lodash";
import { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useNavigate } from "react-router-dom";
import { apiCaller } from "src/util/apiCaller";
import {
  handleExportExcelFuncNew,
  listTrangThai
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";
import ThongKeTongHopTable from "./ThongKeTongHopTable";
const FormItem = Form.Item;

const ThongKeTongHop = ({ status }: any) => {
  const [form] = Form.useForm();
  const { resetFields } = form;
  const { isActive } = status;
  const navigate = useNavigate();
  const [isLoadTable, setIsLoadTable] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [listDanToc, setListDanToc] = useState([]);
  const [loadingDanToc, setLoadingDanToc] = useState(false);
  const [listHanLuuTru, setListHanLuuTru] = useState([]);
  const [loadingHanLT, setLoadingHanLT] = useState(false);
  const [searchParams] = useState({
    trangthai: "",
    madantoc: "",
    idhan: ""
  });
  useEffect(() => {
    if (isActive) {
      getListData(
        searchParams.madantoc,
        searchParams.trangthai,
        searchParams.idhan
      );
      getDanToc();
      getHanLuuTru();
    } else {
      navigate("/error/401");
    }
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: "Tên nhóm tài liệu",
      dataIndex: "tenNhomTuLieu",
      key: "tenNhomTuLieu",
      render: (text, record) => renderTitle(text, record)
    },
    { title: "Tư liệu", dataIndex: "tuLieu", key: "tuLieu" },
    { title: "Hình ảnh", dataIndex: "hinhAnh", key: "hinhAnh" },
    { title: "Video", dataIndex: "video", key: "video" },
    { title: "Tổng", dataIndex: "tong", key: "tong" }
  ];

   /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof DonThuDaNhapList
   */
   const renderTitle = (text: string, record: any) => {
    return (
      <span
        onClick={() =>  navigate(`/thong-ke/chi-tiet/tong-hop-theo-nhom-tu-lieu/${record.idNhomTuLieu}`)}
        style={{ cursor: "pointer", color: "#0065ff" }}
        title="Xem chi tiết"
      >
        {text}
      </span>
    )
   };

  /**
   * getListData: gọi danh sách quyền
   * @param {number} activePage
   * @memberof Quyen
   */
  const getListData = async (madantoc: any, trangthai: any, idhan: any) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/thongke/nhomtulieu?madantoc=${madantoc || ""}&trangthai=${
        trangthai || ""
      }&idhan=${idhan || ""}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listQuyen"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response, "data", []);
        setDataTable(data);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const getDanToc = async () => {
    setLoadingDanToc(true);
    const configAPI = {
      url: `api/dmdc/dantocs`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listDanToc"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = [
          { tenGoi: "---Tất cả---", maDanToc: "" },
          ...get(response, "data", [])
        ];
        setListDanToc(data as any);
        setLoadingDanToc(false);
        false;
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingDanToc(false);
      }
    } finally {
      setLoadingDanToc(false);
    }
  };

  const getHanLuuTru = async () => {
    setLoadingHanLT(true);
    const configAPI = {
      url: `api/hanluutrus?keyword=`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listThoiHanLuuTru"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = [
          { tenHanLuuTru: "---Tất cả---", id: "" },
          ...get(response.data, "content", [])
        ];
        setListHanLuuTru(data as any);
        setLoadingHanLT(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setLoadingHanLT(false);
    }
  };

  const handleXuatExcel = async () => {
    if (!isEmpty(dataTable)) {
      const HTMLTable = await ReactDOMServer.renderToStaticMarkup(
        <ThongKeTongHopTable dataTable={dataTable} />
      );
      handleExportExcelFuncNew(HTMLTable, "THONG_KE_TONG_HOP");
    }
  };

   /**
   * handleReset: làm mới form tìm kiếm
   * @memberof LoaiTaiLieu
   */
   const handleReset = () => {
    resetFields();
  };

  const onFinish = (values: any) => {
    getListData(values.madantoc, values.trangthai, values.idhan);
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>
          Thống kê tổng hợp theo nhóm tài liệu
        </h3>
      </Flex>
      <Card style={{ marginBottom: 15 }}>
        <Form
          layout="vertical"
          form={form}
          name="tulieu-control"
          onFinish={onFinish}
        >
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={8} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Dân tộc"
                  name="madantoc"
                  initialValue={searchParams.madantoc || ""}
                >
                  <Select
                    allowClear
                    showSearch
                    loading={loadingDanToc}
                    placeholder="Chọn dân tộc"
                    style={{ width: "100%" }}
                    options={listDanToc}
                    optionFilterProp="tenGoi"
                    filterOption={(input, option: any) =>
                      (option?.tenGoi ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "tenGoi", value: "maDanToc" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Trạng thái"
                  name="trangthai"
                  initialValue={searchParams.trangthai || ""}
                >
                  <Select
                    allowClear
                    placeholder="Chọn trạng thái"
                    style={{ width: "100%" }}
                    options={[
                      { label: "---Tất cả---", value: "" },
                      ...listTrangThai
                    ]}
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Hạn lưu trữ"
                  name="idhan"
                  initialValue={searchParams.idhan || ""}
                >
                  <Select
                    allowClear
                    loading={loadingHanLT}
                    placeholder="Chọn hạn lưu trữ"
                    style={{ width: "100%" }}
                    options={listHanLuuTru}
                    fieldNames={{ label: "tenHanLuuTru", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={12} xs={24}>
                <FormItem>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px", backgroundColor: "#0d5ace" }}
                    htmlType="submit"
                  >
                    <div className="content-btn">
                      <span className="name">
                        <SearchOutlined /> Tìm kiếm
                      </span>
                    </div>
                  </Button>
                  <Button onClick={handleReset}>
                    <div className="content-btn">
                      <span className="name">
                        <ReloadOutlined /> Làm mới
                      </span>
                    </div>
                  </Button>
                  <Button
                    type="primary"
                    style={{marginLeft: "10px", background: "green" }}
                    onClick={handleXuatExcel}
                  >
                   <FileExcelOutlined /> Xuất excel
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Form>
      </Card>
      <Card>
        <Table
          rowKey={"idNhomTuLieu"}
          bordered
          size="middle"
          columns={columns}
          dataSource={dataTable}
          pagination={false}
          loading={isLoadTable}
          className="qti-table-wrapper gx-table-responsive"
        />
      </Card>
    </Layout>
  );
};

export default ThongKeTongHop;
